import { ReactNode } from "react";
import cx from "classnames";

import useFocusOnModalEnter from "hooks/useFocusOnModalEnter";

import Box, { BoxProps } from "../Box";
import styles from "./styles.module.css";

type DrawerBodyProps = {
  children: ReactNode;
  hasDivider?: boolean;
  shouldFocusOnEnter?: boolean;
  noPadding?: boolean;
  className?: string;
} & Partial<BoxProps>;

const DrawerBody = ({
  children,
  direction = "column",
  justify = "start",
  noPadding,
  hasDivider,
  className,
  shouldFocusOnEnter,
  ...restProps
}: DrawerBodyProps) => {
  const bodyRef = useFocusOnModalEnter({
    shouldFocusOnEnter,
  });

  return (
    <Box
      ref={bodyRef}
      direction={direction}
      justify={justify}
      fullWidth
      className={cx(
        styles.body,
        {
          [styles.hasDivider]: hasDivider,
          [styles.noPadding]: noPadding,
        },
        className
      )}
      {...restProps}
    >
      {children}
    </Box>
  );
};

DrawerBody.displayName = "DS.Drawer.Body";

export default DrawerBody;
